var _defs, _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAviatorSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m13.7612,38.496c-.1523-3.5553-1.6007-5.2306-4.3201-5.2306-2.0299,0-3.9411,1.4917-3.9411,3.8848,0,2.163,1.7767,3.8848,3.8848,3.8848h30.6074c2.5079,0,2.5079-1.9627,2.5079-3.0167s-.6906-2.5079-3.5255-2.5079-4.3251,2.9077-4.3251,2.9077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m19.7417,21.4808c7.5236,7.2828,1.8061,14.2449-7.3985,17.5681"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m24.7816,17.0084c3.7362,3.0507,5.2603,6.3756,5.2603,10.249s-4.079,8.1923-8.2266,10.9002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m36.5645,36.2868c1.1898-3.8535-5.4232-5.1841-10.6347-1.4339"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m25.244,21.2578l-1.6469,1.6469-3.4481-2.7294-1.076,3.4486,1.4312,2.2618-1.1913,1.1659-2.0415-2.1874c-.5384-.5768-.8378-1.3364-.8378-2.1255v-1.7886c-3.6677-4.0447-6.547-7.4382-6.9926-13.9852,6.547.4456,9.9405,3.3249,13.9852,6.9926h1.7886c.789,0,1.5486.2994,2.1255.8378l2.1874,2.0415-1.0735,1.0969-2.3542-1.3368-3.4486,1.076,2.5927,3.5847Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 16.3994,
    cy: 13.8634,
    r: 2.4765
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviatorSvg);
export default __webpack_public_path__ + "static/media/aviator-svg.619c2aaaaff082f565b7a370b3cdf0ec.svg";
export { ForwardRef as ReactComponent };